export function calculateTrend(current: number, previous: number) {
  return Math.round(((current - previous) / previous) * 100);
}
